import { createFeature, createReducer, on } from '@ngrx/store';

import { DocumentVerificationActions } from './document-verification.actions';
import { initialDocumentVerificationState } from './document-verification.state';

export const documentVerificationFeature = createFeature({
  name: 'documentVerification',
  reducer: createReducer(
    initialDocumentVerificationState,
    on(DocumentVerificationActions.loadList, (state, { query }) => ({
      ...state,
      loadingList: true,
      error: null,
      listError: null,
      currentPage: query.page,
      pageSize: query.pageSize,
      listQuery: query,
    })),
    on(
      DocumentVerificationActions.loadListSuccess,
      (state, { rows, total, page, pageSize, stats }) => ({
        ...state,
        rows,
        stats,
        totalDocuments: total,
        currentPage: page,
        pageSize,
        loadingList: false,
        listError: null,
      }),
    ),
    on(DocumentVerificationActions.loadListFailure, (state, { error }) => ({
      ...state,
      rows: [],
      totalDocuments: 0,
      loadingList: false,
      error,
      listError: error,
    })),
    on(DocumentVerificationActions.reviewDocument, (state) => ({
      ...state,
      submitting: true,
      error: null,
      successMessage: null,
    })),
    on(DocumentVerificationActions.reviewDocumentSuccess, (state, { message }) => ({
      ...state,
      submitting: false,
      successMessage: message,
    })),
    on(DocumentVerificationActions.reviewDocumentFailure, (state, { error }) => ({
      ...state,
      submitting: false,
      error,
    })),
    on(DocumentVerificationActions.clearError, (state) => ({
      ...state,
      error: null,
      listError: null,
    })),
    on(DocumentVerificationActions.clearSuccessMessage, (state) => ({
      ...state,
      successMessage: null,
    })),
  ),
});

export const {
  name: documentVerificationFeatureKey,
  reducer: documentVerificationReducer,
  selectRows,
  selectStats,
  selectTotalDocuments,
  selectLoadingList,
  selectSubmitting,
  selectError,
  selectListError,
  selectSuccessMessage,
  selectCurrentPage,
  selectPageSize,
  selectListQuery,
} = documentVerificationFeature;
